import React, { useContext } from 'react';
import './FastRecieve.css';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import FirstEn from '../../../assets/images/mainPbl/fastWay/item1.webp'
import FirstEnWhite from '../../../assets/images/mainPbl/fastWay/item1W.png'

import SecondEn from '../../../assets/images/mainPbl/fastWay/item2.webp'
import SecondEnWhite from '../../../assets/images/mainPbl/fastWay/item2W.png'

import FirthdEn from '../../../assets/images/mainPbl/fastWay/item3.webp'
import FirthdEnWhite from '../../../assets/images/mainPbl/fastWay/item3W.png'

import FourEn from '../../../assets/images/mainPbl/fastWay/item4.webp'
import FourEnWhite from '../../../assets/images/mainPbl/fastWay/item4W.png'

import FirstBgWhite from '../../../assets/images/mainPbl/fastWay/itemBg1W.png'
import FirstBg from '../../../assets/images/mainPbl/fastWay/itemBg1.webp'

import SecondBg from '../../../assets/images/mainPbl/fastWay/itemBg2.webp'
import SecondBgWhite from '../../../assets/images/mainPbl/fastWay/itemBg2W.png'

import FirthdBg from '../../../assets/images/mainPbl/fastWay/itemBg3.webp'
import FirthdBgWhite from '../../../assets/images/mainPbl/fastWay/itemBg3W.png'

import FourBg from '../../../assets/images/mainPbl/fastWay/itemBg4.webp'
import FourBgWhite from '../../../assets/images/mainPbl/fastWay/itemBg4W.png'

import useWindowSize from '../../../assets/hooks/useWindowSize';
import { THEME_LIGHT_TYPE } from '../../../assets/utils/constants';
import { ThemeContext } from '../../../assets/contexts/themeContext';

function FastRecieve({ language }) {
    const { mainPbl } = useContext(TranslationContext);
    const { mainFastRecieve } = mainPbl;
    const { width } = useWindowSize()
    const { theme } = useContext(ThemeContext);

    const CARDS = [
        {
            en: FirstEn,
            bg: FirstBg,
            enW: FirstEnWhite,
            bgW: FirstBgWhite,
        },
        {
            en: SecondEn,
            bg: SecondBg,
            enW: SecondEnWhite,
            bgW: SecondBgWhite
        },
        {
            en: FirthdEn,
            bg: FirthdBg,
            enW: FirthdEnWhite,
            bgW: FirthdBgWhite
        },
        {
            en: FourEn,
            bg: FourBg,
            enW: FourEnWhite,
            bgW: FourBgWhite
        },
    ]

    return (
        <div className='fast-recieve'>
            <button className={`fast-recieve__button head-banner__button_pc`} type='button'>
                {mainFastRecieve.textOnGreen}
            </button>

            <p className='fast-recieve__title'>{mainFastRecieve.title}</p>
            <p className='fast-recieve__subtitle'>{mainFastRecieve.subtitle}</p>

            <div className='fast-recieve__cards-grid'>
                {CARDS.map((item, i) => {
                    return (
                        theme === THEME_LIGHT_TYPE ?
                            <img src={language === 'EN' ? item.en : item.bg} alt='' className='fast-recieve__card__img'></img>
                            :
                            <img src={language === 'EN' ? item.enW : item.bgW} alt='' className='fast-recieve__card__img'></img>
                        // <div className='fast-recieve__card'>
                        //     <img src={language === 'EN' ? item.en : item.bg} alt='' className='fast-recieve__card__img'></img>
                        //     <p className='fast-recieve__card__text'>You provide products and services—now enhance your clients’ payment experience.</p>
                        // </div>
                    )
                })}
            </div>
        </div>
    )
}
export default FastRecieve